<template>
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-press-escape="true"
      custom-class="elsa-modal"
      :center="false"
      width="450px"
      top="100px"
      v-on:closed="closed"
    >
      <div slot="title">
        <h1>{{ $t("login.sso.title") }}</h1>
        <p>{{ $t("login.sso.description") }}</p>
      </div>
  
      <slot>
        <api-errors :errors="errors" />
        <el-form :model="form" :rules="rules" ref="form">
          <elsa-input
            name="email"
            :label="$t('login.sso.email')"
            :placeholder="$t('login.sso.email_placeholder')"
            v-model.trim.lazy="form.email"
            ref="emailField"
          />
          <span class="dialog-footer elsa-button-footer">
            <primary-button
              ref="submit"
              v-loading="loading"
              type="submit"
              @click.native="submitLoginSso"
              disabled
            >
              {{ $t("common.continue") }}
            </primary-button>
          </span>
        </el-form>
      </slot>
    </el-dialog>
  </template>
  
  <script>
  import PrimaryButton from "@/components/common/buttons/PrimaryButton";
  import ElsaInput from "@/components/common/Input";
  import ApiErrors from "@/components/common/ApiErrors";
  import {
    handleFormValidation,
    handleSubmitButtonState,
    isPropEmpty,
  } from "@/helpers/formValidationHelper";
  import axios from "@/utils/axios";
  import { compose, isEmpty, either, isNil, not } from "ramda";
  
  export default {
    name: "SsoLogin",
    props: ["dialogVisible"],
    components: {
      PrimaryButton,
      ElsaInput,
      ApiErrors,
    },
    data() {
      return {
        loading: false,
        form: {},
        sendPasswordSuccess: false,
        errors: [],
        rules: {
          email: [
            {
              message: this.$t('login.sso.email_validation_msg'),
              trigger: ["blur"],
              validator: (rule, value, callback) => {
                const isValid = compose(not, either(isNil, isEmpty));
                if (!isValid(value)) {
                  return callback(new Error(this.$t('login.sso.email_validation_msg')));
                }
                return callback();
              },
            },
            {
              type: "email",
              message: this.$t('login.sso.email_validation_msg'),
              trigger: "blur",
            },
          ],
        },
      };
    },
    methods: {
      handleClose() {
        this.dialogVisible = false;
        this.resetForm();
      },
      onFormChange() {
        handleSubmitButtonState(
          this.$refs.submit.$el,
          !isPropEmpty("email")(this.form)
        );
      },
      submitLoginSso(e) {
        e.preventDefault();
        this.loading = true;
        handleFormValidation(this.$refs.form, this.loginSsoRequest, () => {
          this.dialogVisible = true;
        }).finally(() => (this.loading = false));
      },
      loginSsoRequest() {
        // const url = `${process.env.VUE_APP_API_BASE_URL}${API_SSO_AUTH}`
        const API_SSO_AUTH = "/v2/accounts/sso/auth/";
        const payload = { email: this.form.email,  app_id: 'b2b_dashboard', redirect_url: `${window.location.origin}/login` };   
        axios
          .post(API_SSO_AUTH, payload)
          .then((response) => {
            this.resetForm();
            this.loading = false;
            const authorization_url = response.data.authorization_url;
            window.location.href = authorization_url;
          })
          .catch((error) => {
            this.loading = false;
            this.errors = [this.$t(`login.sso.${error.response.data["key"]}`)] || [
              this.$t("common.generic_error_message"),
            ];
          });
      },
      resetForm() {
        if (this.$refs.form) {
            this.$refs.form.resetFields();
        }
        this.errors = [];
      },
      closed() {
        this.$emit("closed");
      },
    },
    mounted() {
        this.resetForm();
    },
    watch: {
    //   dialogVisible: {
    //     immediate: true,
    //     deep: true,
    //     handler(visible) {
    //       if (visible) {
    //         this.$nextTick(() => {
    //             this.resetForm();
    //             this.onFormChange();
    //         });
    //       }
    //     },
    //   },
      form: {
        deep: true,
        handler() {
          return this.onFormChange()
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .elsa-button {
    width: 202px;
  }
  
  h2.info {
    line-height: 28px;
    padding-bottom: 32px;
    width: 380px;
  }
  
  img {
    margin-top: 8px;
  }
  </style>
  